/* eslint-disable import/first,comma-spacing,spaced-comment,quotes,no-undef */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import {user} from './modules/user'
import {activity} from './modules/activity'
import {outRecord} from './modules/outRecord'
import {stompSocket} from './modules/stompSocket.js'
import {layout} from './modules/layout.js'
import {middleware} from './modules/middleware/middleware.js'
import {baseInfo} from "./modules/baseInfo";
import {dpcOrder} from "./modules/dpcOrder";
import {archiveMenuConfig} from "./modules/archiveMenuConfig";
import {sysDict} from "./modules/sysDict.js";


export default new Vuex.Store({
  modules: {
    activity,
    stompSocket,
    outRecord,
    layout,
    middleware,
    baseInfo,
    dpcOrder,
    archiveMenuConfig,
    sysDict,
  },
  ...user
})



// WEBPACK FOOTER //
// ./src/store/index.js